module.exports = __webpack_public_path__ + "images/royal-canin.sprite--breed--brand1--xs.80a2ea936b3133abcbdc523a1abfd160.svg";